import React from "react";
import styled from "styled-components";
import Container from "../../Components/Container";
import Typewriter from "typewriter-effect";

const Title = styled.h1`
  font-weight: 300;
  font-size: 65px;
  color: #fff;
  min-height: 450px; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 40px;
    min-height: 300px;
  }
`;

const SpanText = styled.span`
  font-weight: 300;
  font-size: 20px;
  line-height: 30px;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const Home = () => {
  return (
    <Container style={{ textAlign: "center", paddingBottom: '120px', paddingTop: '120px' }} id="section-1">
      <Title>
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(
                `Seu cliente não espera. <br/> O <span style="color:#E4DA1B;">Alfred</span> também não.`
              ).start();
          }}
          options={{
            autoStart: true,
            loop: false,
            delay: 50,
          }}
        />
      </Title>
      <SpanText>
        {" "}
        O alfred responde{" "}
        <span style={{ fontWeight: "bold" }}>24h por dia</span>. Conhece seu
        negócio e{" "}
      </SpanText>{" "}
      <br /> <SpanText> nunca deixa um cliente sem resposta </SpanText>
    </Container>
  );
};

export default Home;
